// extracted by mini-css-extract-plugin
export default {"description":"oLALRXRR3CFN4NsKB44e"};